import type { RuntimeClientBundle, RuntimeFieldState, RuntimeProvider, ProviderItem } from './types'

const empty = (value: unknown) => value == null || value === '' || (Array.isArray(value) && !value.length)
function scalars(value: unknown): string[] {
  if (value == null || value === '') return []
  if (typeof value === 'object') return Object.values(value).flatMap(scalars)
  return [String(value)]
}
export function localProviderItems(provider: RuntimeProvider, values: Record<string, unknown>): ProviderItem[] {
  if (provider.type === 'remote') return []
  if ((provider.depends_on || []).some(id => empty(values[id]))) return []
  return provider.items.filter(item => provider.type !== 'snapshot' || (provider.filters || []).every(filter => {
    const expected = scalars(values[filter.source_field])
    const actual = scalars(item.meta?.[filter.meta_key])
    return expected.some(value => actual.includes(value))
  }))
}
export function localProviderState(bundle: RuntimeClientBundle, values: Record<string, unknown>) {
  return Object.fromEntries(Object.entries(bundle.providers).map(([id, provider]) => {
    const items = localProviderItems(provider, values)
    return [id, { items, count: items.length, empty: !items.length }]
  }))
}
function scalar(value: unknown, type: string) {
  if (type === 'number') { if (typeof value !== 'number' || !Number.isFinite(value)) throw new Error('Ожидается число'); return }
  if (typeof value !== 'string') throw new Error('Ожидается строка')
  if (type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) throw new Error('Укажите корректный email')
  if (type === 'phone' && !/^[+\d() .-]{5,40}$/.test(value)) throw new Error('Укажите корректный телефон')
  if (type === 'url') { const url = new URL(value); if (!['http:', 'https:'].includes(url.protocol) || !url.hostname) throw new Error('Укажите ссылку http:// или https://') }
  if (type === 'time') { const [hour, minute, second = '0'] = value.split(':'); if (!/^\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(value) || Number(hour) > 23 || Number(minute) > 59 || Number(second) >= 60) throw new Error('Укажите время') }
  if (type === 'date' && (!/^\d{4}-\d{2}-\d{2}$/.test(value) || new Date(value).toISOString().slice(0, 10) !== value)) throw new Error('Укажите дату')
  if (type === 'datetime') { if (!/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(value) || Number.isNaN(new Date(value).getTime())) throw new Error('Укажите дату и время'); scalar(value.slice(0, 10), 'date'); scalar(value.slice(11, 16), 'time') }
}
export function validateLocalValues(bundle: RuntimeClientBundle, states: Record<string, RuntimeFieldState>, values: Record<string, unknown>) {
  const normalized = { ...values }
  let bytes = 0
  for (const [id, field] of Object.entries(bundle.fields)) {
    const state = states[id]
    if (!state?.visible) continue
    const value: any = state.value
    if (state.required && empty(value)) throw new Error(field.label + ': поле обязательно')
    if (empty(value)) continue
    try {
      const type = field.type
      if (['text', 'textarea', 'email', 'phone', 'url', 'date', 'datetime', 'time', 'number'].includes(type)) scalar(value, type)
      if (typeof value === 'string' && (field.min_length != null && value.length < field.min_length || field.max_length != null && value.length > field.max_length)) throw new Error('Недопустимая длина')
      if (type === 'number' && (field.min != null && value < Number(field.min) || field.max != null && value > Number(field.max))) throw new Error('Число вне допустимого диапазона')
      if (type === 'checkbox' && typeof value !== 'boolean') throw new Error('Ожидается логическое значение')
      if (type === 'select') {
        if (field.multiple ? !Array.isArray(value) : typeof value === 'object') throw new Error('Некорректное выбранное значение')
        const provider = bundle.providers[field.provider!]
        if (!provider || provider.type === 'remote') throw new Error('Источник требует платного серверного режима')
        const allowed = new Set(localProviderItems(provider, values).map(item => String(item.value)))
        if ((Array.isArray(value) ? value : [value]).some(item => !allowed.has(String(item)))) throw new Error('Выбранного значения нет в справочнике')
      }
      if (type === 'money') { scalar(value.amount, 'number'); if (!/^[A-Z]{3}$/.test(value.currency || '')) throw new Error('Укажите валюту') }
      if (type === 'file') {
        const files = field.multiple ? value : [value]
        if (!Array.isArray(files) || files.length > (field.max_files ?? 10)) throw new Error('Превышен лимит файлов')
        for (const file of files) {
          if (!file || typeof file.name !== 'string' || !file.name.trim() || file.name.length > 255 || /[\\/\0]/.test(file.name)) throw new Error('Некорректное имя файла')
          if (typeof file.data !== 'string' || !/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(file.data)) throw new Error('Некорректный файл')
          const size = file.data.length / 4 * 3 - (file.data.endsWith('==') ? 2 : file.data.endsWith('=') ? 1 : 0)
          if (size > (field.max_size_mb ?? 10) * 1048576) throw new Error('Превышен размер файла')
          const accept = (field.accept || '').split(',').map(item => item.trim().toLowerCase()).filter(Boolean)
          if (accept.length && !accept.some(item => item.startsWith('.') ? file.name.toLowerCase().endsWith(item) : item.endsWith('/*') ? String(file.content_type).toLowerCase().startsWith(item.slice(0, -1)) : String(file.content_type).toLowerCase() === item)) throw new Error('Недопустимый тип файла')
          bytes += size
        }
      }
      if (['multivalue', 'crm_multifield'].includes(type)) {
        if (!Array.isArray(value) || value.length > (field.max_items ?? 100)) throw new Error('Превышен лимит значений')
        for (const item of value) {
          if (type === 'multivalue') { scalar(item, field.item_type || 'text'); if (item === '') throw new Error('Заполните или удалите пустую строку') }
          else {
            if (!['PHONE', 'EMAIL', 'WEB', 'IM'].includes(item.typeId) || !['WORK', 'HOME', 'MOBILE', 'OTHER', 'MAILING'].includes(item.valueType)) throw new Error('Некорректный тип контакта CRM')
            scalar(item.value, ({ PHONE: 'phone', EMAIL: 'email', WEB: 'url' } as Record<string, string>)[item.typeId] || 'text')
          }
        }
      }
      normalized[id] = value
    } catch (error) { throw new Error(field.label + ': ' + (error as Error).message) }
  }
  if (bytes > 20 * 1048576) throw new Error('Общий размер файлов превышает 20 МБ')
  return normalized
}
